/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Members_Add_Submit_PayInputs */



/**
* | output |
* | --- |
* | "Invite and pay {amount}" |
*
* @param {Members_Add_Submit_PayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_add_submit_pay = /** @type {((inputs: Members_Add_Submit_PayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Add_Submit_PayInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Einladen und ${i?.amount} bezahlen`)
	return /** @type {LocalizedString} */ (`Invite and pay ${i?.amount}`)
});